import * as _actions from './actions';
import _reducer from './reducer';
import * as _Status from './status';
import * as _accessors from './accessors';

export const actions = _actions;
export const reducer = _reducer;
export const Status = _Status;
export const accessors = _accessors;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/index.js